export function formatAmount(amount: number, currency: string): string {
  return new Intl.NumberFormat("en-TZ", {
    style: "currency",
    currency,
    minimumFractionDigits: 0,
  }).format(amount);
}

/** Format an informational secondary-currency amount (always 2 decimals). */
export function formatDisplayAmount(amount: number, currency: string): string {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency,
    currencyDisplay: "narrowSymbol",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount);
}

/**
 * Formats a field label by converting underscore-separated keys to title case.
 * Also handles labels that might already have colons.
 * e.g., "delivery_address" -> "Delivery Address"
 * e.g., "Delivery Address" -> "Delivery Address" (unchanged)
 */
export function formatFieldLabel(label: string): string {
  // Remove any trailing colon and spaces
  const cleanLabel = label.replace(/:\s*$/, "").trim();

  // Check if the label contains underscores (likely a key format)
  if (cleanLabel.includes("_")) {
    return cleanLabel
      .split("_")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");
  }

  // Return as-is if it's already formatted properly
  return cleanLabel;
}
